// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__r63M6","modal":"Modal_modal__DJDMv","header":"Modal_header__fOQI0","title":"Modal_title__3HkNf","close":"Modal_close__V34Fj","body":"Modal_body__q5AFJ"};